import { Injectable }       from '@angular/core';
import {
  CanActivate, Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateChild,
  CanLoad, Route
}                           from '@angular/router';
import { AuthService }      from './auth.service';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/first';
import { Observable } from 'rxjs/Observable';

import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';
import { Angulartics2GoogleAnalytics, Angulartics2 } from 'angulartics2';
@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(private authService: AuthService, private router: Router, private afDatabase: AngularFireDatabase, public afAuth: AngularFireAuth, private angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics, private angulartics2: Angulartics2) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    let url: string = state.url;
    return this.afAuth.authState.map((auth) =>  {
      
      if(auth == null) {
        this.router.navigate(['/login'],{ queryParams: { redirect:url}});
        return false;
      } else {
        this.angulartics2.settings.ga.userId = this.authService.authDetails['uid']
        this.authService.authDetails = auth;
        return true;
      }
    }).first()
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.afDatabase.object('auth/hoxbies/').map((result) => {
      if(result[this.authService.authDetails['uid']] != undefined){
        return true
      } else {
        this.router.navigate(['/login'])
        return false
      }
    })
    //return this.canActivate(route, state);
  }

  canLoad(route: Route): boolean {
    let url = `/${route.path}`;
    return this.checkLogin(url);
  }

  checkLogin(url: string): boolean {
    if (this.authService.isLoggedIn) { return true; }

    // Store the attempted URL for redirecting
    this.authService.redirectUrl = url;
    
    // Navigate to the login page with query params
    this.router.navigate(['/login'],{ queryParams: { redirect:url}});
    return false;
  }
}

@Injectable()
export class AuthGuardAdmin implements CanActivate, CanActivateChild, CanLoad {
  constructor(private authService: AuthService, private router: Router, private afDatabase: AngularFireDatabase) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    let url: string = state.url;
    return this.afDatabase.object('auth/admin/').map((result) => {
      if(result[this.authService.authDetails['uid']] != undefined){
        return true
      } else {
        this.router.navigate(['/'])
        return false
      }
    })
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.canActivate(route, state);
  }

  canLoad(route: Route): boolean {
    let url = `/${route.path}`;
    return this.checkLogin(url);
  }

  checkLogin(url: string): boolean {
    if (this.authService.isLoggedIn) { return true; }

    // Store the attempted URL for redirecting
    this.authService.redirectUrl = url;
    
    // Navigate to the login page with query params
    this.router.navigate(['/login'],{ queryParams: { redirect:url}});
    return false;
  }
}


// WEBPACK FOOTER //
// /Users/jackwoodward/Desktop/JCW Services/Huckleberry Partners/Hoxby Internal Projects/intranet/hoxbyHub/src/app/auth-guard.service.ts